import React from 'react'

import './Embed.css'

export default ({ content }) => {
    return (
        <section className="Embed" dangerouslySetInnerHTML={{ __html: content.code }} />
    )
}